import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Header from './Header';
import PrivateAppShell from './PrivateAppShell';
import { isAuthenticated } from '../../utils/authStorage';

interface LayoutProps {
  children: ReactNode;
}

const PRIVATE_PATH_PREFIXES = [
  '/dashboard',
  '/processo',
  '/cadastro-clientes',
  '/pastas',
  '/habita',
  '/kanban',
  '/marketing',
  '/comercial',
  '/usuarios',
  '/parametros',
];

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const requestedPath = `${location.pathname}${location.search}${location.hash}`;
  const isPrivateArea = PRIVATE_PATH_PREFIXES.some((path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  if (isPrivateArea) {
    if (!isAuthenticated()) {
      return (
        <Navigate
          to={{ pathname: '/login', search: `?redirect=${encodeURIComponent(requestedPath)}` }}
          replace
          state={{ from: requestedPath }}
        />
      );
    }

    return <PrivateAppShell>{children}</PrivateAppShell>;
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>{children}</main>
    </div>
  );
}
